import React, { useState, useEffect } from 'react';
import PieChartComponent from '@/components/charts/Pie';
import LineChartComponent from '@/components/charts/Line';
import { TotalData, TradingTabKeyNames } from '../../index.type';
import { times100 } from '@/lib/utils';
interface TradingWinRateProps {
  selectedMetrics: {
    tradingWinRate?: boolean;
    [key: string]: boolean | undefined;
  };
  totalData: Pick<TotalData, TradingTabKeyNames>;
}

const TradingWinRate: React.FC<TradingWinRateProps> = ({ selectedMetrics, totalData }) => {
  const [currentSelectedMetrics, setCurrentSelectedMetrics] = useState<{
    tradingWinRate?: boolean;
    [key: string]: boolean | undefined;
  }>({});

  // 饼图数据状态
  const [pieData, setPieData] = useState([
    { name: '盈利', value: 68, color: '#5959EB' },
    { name: '亏损', value: 32, color: '#FF7B52' }
  ]);

  useEffect(() => {
    console.log(times100(totalData.trading_win_rate || 0).toNumber(), 'dldlddl');

    const winRate = times100(totalData.trading_win_rate || 0)?.toNumber() || 0;
    const lossRate = 100 - winRate;
    console.log(winRate, lossRate, 'winRate, lossRate');

    setPieData([
      { name: '盈利', value: winRate, color: '#5959EB' },
      { name: '亏损', value: lossRate, color: '#FF7B52' }
    ]);
  }, [totalData.trading_win_rate]);

  // 图表数据状态
  const [chartData, setChartData] = useState({
    industryReturn: [{ value: 0 }, { value: 15 }, { value: 25 }, { value: 35 }, { value: 48.2 }],
    stockReturn: [{ value: 0 }, { value: 20 }, { value: 40 }, { value: 60 }, { value: 73.5 }]
  });

  // 收益数值状态
  const [returnValues, setReturnValues] = useState({
    industry: 4.82,
    stock: 7.35
  });

  useEffect(() => {
    setCurrentSelectedMetrics(selectedMetrics);
  }, [selectedMetrics]);

  // 模拟接口获取数据
  const fetchTradingData = async () => {
    try {
      // 模拟API调用延迟
      await new Promise(resolve => setTimeout(resolve, 500));

      // 模拟接口返回的数据
      const mockApiResponse = {
        winRate: {
          profit: Math.floor(Math.random() * 20) + 60, // 60-80之间的随机数
          loss: Math.floor(Math.random() * 20) + 20 // 20-40之间的随机数
        },
        returns: {
          industry: Array.from({ length: 5 }, (_, i) => ({
            value: Math.max(0, Math.random() * 50 + i * 10)
          })),
          stock: Array.from({ length: 5 }, (_, i) => ({
            value: Math.max(0, Math.random() * 80 + i * 15)
          }))
        },
        returnValues: {
          industry: Number((Math.random() * 10 + 2).toFixed(2)), // 2-12之间的随机数
          stock: Number((Math.random() * 15 + 5).toFixed(2)) // 5-20之间的随机数
        }
      };

      // 更新饼图数据
      // setPieData([
      //   {
      //     name: '盈利',
      //     value: mockApiResponse.winRate.profit,
      //     color: '#5959EB'
      //   },
      //   { name: '亏损', value: mockApiResponse.winRate.loss, color: '#FF7B52' }
      // ]);

      // 更新线性图数据
      setChartData({
        industryReturn: mockApiResponse.returns.industry,
        stockReturn: mockApiResponse.returns.stock
      });

      // 更新收益数值
      setReturnValues({
        industry: mockApiResponse.returnValues.industry,
        stock: mockApiResponse.returnValues.stock
      });

      console.log('交易数据已更新:', mockApiResponse);
    } catch (error) {
      console.error('获取交易数据失败:', error);
    }
  };

  // 模拟数据变化
  useEffect(() => {
    // 初始加载数据
    fetchTradingData();

    // 设置定时器定期更新数据
    const interval = setInterval(() => {
      fetchTradingData();
    }, 3000); // 每3秒更新一次数据

    return () => clearInterval(interval);
  }, []);

  const handleCheckboxChange = (checked: boolean) => {
    setCurrentSelectedMetrics(prev => ({
      ...prev,
      tradingWinRate: checked
    }));
  };

  return (
    <div className="my-4 rounded-lg border border-[#F0F0F0] p-3">
      {/* 标题和复选框 */}
      <div className="mb-4 flex items-center gap-2">
        <input
          type="checkbox"
          checked={currentSelectedMetrics.tradingWinRate || false}
          onChange={e => handleCheckboxChange(e.target.checked)}
          className="h-4 w-4"
        />
        <span className="text-base font-semibold text-[#1F1F1F]">交易胜率</span>
      </div>

      {/* 主要内容区域 */}
      <div className="flex items-center justify-between gap-8">
        {/* 左侧：饼图和图例 */}
        <PieChartComponent
          data={pieData}
          width="90px"
          height="90px"
          innerRadius={35}
          outerRadius={45}
          startAngle={90}
          endAngle={450}
          showLegend={true}
          legendPosition="right"
        />

        {/* 右侧：收益卡片 */}
        <div className="flex flex-1 gap-2">
          {/* 行业配置收益 */}
          <div className="flex h-[114px] w-1/2 flex-col gap-3 rounded-md border border-[#F0F0F0] bg-white p-2">
            <div className="flex flex-col">
              <span className="text-xs text-[#1F1F1F]">行业配置收益</span>
              <span className="text-base font-semibold text-[#F5222D]">
                +{returnValues.industry}%
              </span>
            </div>
            <div className="flex-1">
              <LineChartComponent data={chartData.industryReturn} stroke="#5959EB" height="42px" />
            </div>
          </div>

          {/* 持股收益 */}
          <div className="flex h-[114px] w-1/2 flex-col gap-3 rounded-md border border-[#F0F0F0] bg-white p-2">
            <div className="flex flex-col">
              <span className="text-xs text-[#1F1F1F]">持股收益</span>
              <span className="text-base font-semibold text-[#F5222D]">+{returnValues.stock}%</span>
            </div>
            <div className="flex-1">
              <LineChartComponent data={chartData.stockReturn} stroke="#1677FF" height="34px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingWinRate;
